<template>
  <div class="construir-pdf">
    <!-- Painel de Customização -->
    <div class="config-panel">
      <div class="config-header">
        <h3><i class="fa fa-sliders" aria-hidden="true"></i> Exportar Relatório em PDF</h3>
        <p>Selecione o órgão de origem para carregar os colegiados e configurar o relatório final.</p>
      </div>

      <!-- 1. Barra de Pesquisa de Órgão -->
      <div class="field-export-info" style="margin-bottom:20px">
        <h4 class="section-subtitle">
          <i class="fa fa-university" aria-hidden="true"></i> 
          Selecione um órgão *
        </h4>
        <v-select
          class="vselect" 
          v-model="selectedOrgaoSelecionado" 
          id="selectedOrgao" 
          :options="paginated"
          label="label" 
          placeholder="Selecione um órgão..."
          :filterable="false" 
          @search="onSearch"
        >
          <li slot="list-footer" class="pagination" style="display: flex; justify-content: space-between; padding: 5px 10px;">
            <button :disabled="!hasPrevPage" @click.prevent="offset -= limit" class="btn-pag-arrow">Anterior</button>
            <button :disabled="!hasNextPage" @click.prevent="offset += limit" class="btn-pag-arrow">Próxima</button>
          </li>
        </v-select>
      </div>

      <!-- 2. Seleção dos Colegiados do Órgão -->
      <div class="status-filter-section" v-if="selectedOrgaoSelecionado && colegiadosLote.length > 0" style="margin-bottom: 20px;">
        <h4 class="section-subtitle">
          <i class="fa fa-cubes" aria-hidden="true"></i> 
          Escolha quais colegiados deseja exportar no relatório *
        </h4>
        
        <div class="marcar-tudo-container">
          <label class="checkbox-item line-box">
            <input type="checkbox" v-model="marcarTodosColegiados">
            <span>Marcar / Desmarcar todos os colegiados</span>
          </label>
        </div>

        <div class="checkbox-grid">
          <label v-for="col in colegiadosLote" :key="col.id" class="checkbox-item line-box">
            <input type="checkbox" :value="col.id" v-model="colegiadosFiltro">
            {{ col.sigla ? col.sigla + ' - ' + col.nome : col.nome }}
          </label>
        </div>
      </div>

      <!--4.1. Opção de exportar mandatos do colegiado -->
      <div class="field-export-info" style="margin-bottom:20px" v-if="selectedOrgaoSelecionado && colegiadosFiltro.length > 0">
        <h4 class="section-subtitle">
          <i class="fa fa-users" aria-hidden="true"></i> 
          Exportar Mandatos do colegiado?
        </h4>
        <div class="checkbox-grid">
          <label class="checkbox-item status-box line-box">
            <input type="checkbox" v-model="exportarMandatos">
            Sim, incluir seção com a lista de mandatos dos membros
          </label>
        </div>
      </div>

      <!-- 3. Filtro de Mandatos por Status -->
      <div class="status-filter-section" v-if="selectedOrgaoSelecionado && colegiadosLote.length > 0 && exportarMandatos">
        <h4 class="section-subtitle">
          <i class="fa fa-filter" aria-hidden="true"></i> 
          Filtrar mandatos por status *
        </h4>
        
        <div class="marcar-tudo-container" v-if="statusDisponiveis.length > 0">
          <label class="checkbox-item line-box">
            <input type="checkbox" v-model="marcarTodosStatus" >
            <span>Marcar / Desmarcar todos os status</span>
          </label>
        </div>
        <div class="checkbox-grid" v-if="statusDisponiveis.length > 0">
          <label v-for="status in statusDisponiveis" :key="status" class="checkbox-item line-box status-badge">
            <input type="checkbox" :value="status" v-model="StatusFiltro">
            {{ status || 'Sem Status' }}
          </label>
        </div>
        <p v-else class="no-status-msg">Nenhum status de mandato disponível. Selecione algum colegiado</p>
      </div>

      <!-- 4. Opção de exportar composição do colegiado -->
      <div class="field-export-info" style="margin-bottom:20px" v-if="selectedOrgaoSelecionado && colegiadosFiltro.length > 0">
        <h4 class="section-subtitle">
          <i class="fa fa-info-circle" aria-hidden="true"></i> 
          Exportar Composição do colegiado?
        </h4>
        <div class="checkbox-grid">
          <label class="checkbox-item status-box line-box" >
            <input type="checkbox" v-model="exportarInfosGerais">
            Sim, incluir seção com regras de composição do colegiado
          </label>
        </div>
      </div>


      <!-- 5.. Painel de Opções de Personalização -->
      <div class="field-export-info" v-if="selectedOrgaoSelecionado && colegiadosFiltro.length > 0" style="margin-bottom:20px">
        <h4 class="section-subtitle">
          <i class="fa fa-cog" aria-hidden="true"></i> 
          Deseja editar a exibição das colunas e tabelas?
        </h4>
        <div class="checkbox-grid">
          <label class="checkbox-item status-box line-box" >
            <input type="checkbox" v-model="mostrarPersonalizacao">
            Sim, quero editar as colunas
          </label>
        </div>
      </div>

      <!-- Seção com Drag and Drop das Colunas -->
      <transition name="slide">
        <div v-if="mostrarPersonalizacao && colegiadosFiltro.length > 0">
          
          <!-- Ordenar Colunas do Colegiado -->
          <div class="filter-section" v-if="exportarInfosGerais" style="margin-bottom: 20px;">
            <h4 class="section-subtitle">
              <i class="fa fa-university" aria-hidden="true"></i> 
              Selecione e arraste para ordenar as colunas do Colegiado
            </h4>
            <div class="marcar-tudo-container">
              <label class="checkbox-item line-box">
                <input type="checkbox" v-model="marcarTodosCamposColegiado">
                <span>Marcar / Desmarcar todos os campos do Colegiado</span>
              </label>
            </div>
            <div class="drag-container">
              <div 
                v-for="(field, index) in ordemColegiado" 
                :key="field" 
                class="drag-card"
                :class="{ 'arrastando': index === draggedIndexColegiado }"
                :draggable="true"
                @dragstart="iniciarArrastoColegiado(index, $event)"
                @dragover.prevent="aoPassarPorCima(index, $event)"
                @drop.prevent="aoSoltarColegiado(index, $event)"
                @dragend="fimArrastoColegiado"
              >
                <div class="drag-handle" title="Clique e arraste para ordenar">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </div>
                <label class="checkbox-item">
                  <input type="checkbox" v-model="camposColegiadoSelecionados[field]">
                  <span>{{ camposColegiado[field] }}</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Ordenar Colunas do Mandato -->
          <div class="fields-filter-section" v-if="exportarMandatos">
            <h4 class="section-subtitle">
              <i class="fa fa-list-ul" aria-hidden="true"></i> 
              Selecione e arraste para ordenar as colunas dos Mandatos
            </h4>
            <div class="marcar-tudo-container">
              <label class="checkbox-item line-box">
                <input type="checkbox" v-model="marcarTodosCampos">
                <span>Marcar / Desmarcar todos os campos</span>
              </label>
            </div>
            <div class="drag-container">
              <div 
                v-for="(field, index) in ordemCampos" 
                :key="field" 
                class="drag-card"
                :class="{ 'arrastando': index === draggedIndex }"
                :draggable="true"
                @dragstart="iniciarArrasto(index, $event)"
                @dragover.prevent="aoPassarPorCima(index, $event)"
                @drop.prevent="aoSoltar(index, $event)"
                @dragend="fimArrasto"
              >
                <div class="drag-handle" title="Clique e arraste para ordenar">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </div>
                <label class="checkbox-item">
                  <input type="checkbox" v-model="camposSelecionados[field]" :disabled="field === 'index_col'">
                  <span>{{ camposMandato[field] }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- Campo de observação -->
      <div class="obs-input-section" v-if="selectedOrgaoSelecionado">
        <p>Adicione uma observação (Opcional)</p>
        <input type="text" class="obs-input" placeholder="Observação..." v-model="observacaoUsuario">
      </div>

      <!-- Ações do Painel -->
      <div class="config-actions">
        <button class="btn-cancelar" @click="$emit('cancelar')">
          Cancelar e Voltar
        </button>

        <button 
          class="btn-gerar" 
          :disabled="gerando || carregandoDadosLote || !selectedOrgaoSelecionado || colegiadosFiltro.length === 0 || (!exportarInfosGerais && !exportarMandatos)" 
          @click="gerarPdf"
        >
          <i class="fa" :class="gerando ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
          {{ gerando ? 'Gerando Documento...' : 'Gerar e Baixar PDF' }}
        </button>
      </div>
    </div>

    <!-- Template Oculto do Banner (Para o html2canvas gerar a imagem de cabeçalho) -->
    <CabecalhoPdf ref="cabecalhoPdf" />

    <!-- Renderização temporária para o pdf -->
    <div v-show="gerando" class="pdf-preview-container">
      <div ref="printableArea" class="pdf-document">

        <!-- LOOP DOS COLEGIADOS SELECIONADOS -->
        <template v-for="(colItem, colIdx) in colegiadosFiltradosLote">
          
          <!-- LOOP DAS PÁGINAS INDIVIDUAIS DE CADA COLEGIADO -->
          <div 
            v-for="(paginaMandatos, pagIdx) in obterPaginasDoColegiado(colItem)" 
            :key="colItem.id + '-' + pagIdx"
            class="pdf-page-wrapper"
            :class="{ 'quebra-pagina-lote-sempre': colIdx > 0 || pagIdx > 0 }"
          >

            <!-- Seção 1: Composição -->
            <div class="pdf-section" v-if="exportarInfosGerais && pagIdx === 0">
              <h2 class="pdf-section-title">1. Composição</h2>
              <div v-if="colunasColegiadoSelecionadas.length === 0" class="pdf-no-data-msg">
                Nenhum campo selecionado para a seção de Colegiado.
              </div>
              <table v-else class="pdf-info-table">
                <thead>
                  <tr>
                    <template v-for="coluna in colunasColegiadoSelecionadas">
                      <th 
                        v-if="!(coluna.field.includes('suplentes') && !colItem.quantidade_membros_suplentes_maximo)"
                        :key="coluna.field" 
                        :style="{ width: (100 / colunasColegiadoSelecionadas.length) + '%' }"
                      >
                        {{ coluna.label }}
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <template v-for="coluna in colunasColegiadoSelecionadas">
                      <td 
                        v-if="!(coluna.field.includes('suplentes') && !colItem.quantidade_membros_suplentes_maximo)"
                        :key="coluna.field"
                        class="pdf-value-cell"
                      >
                        <template v-if="coluna.field === 'quantidade_membros_titulares_minimo'">
                          {{ colItem.quantidade_membros_titulares_minimo || 'Não informado' }}
                        </template>
                        <template v-else-if="coluna.field === 'quantidade_membros_titulares_maximo'">
                          {{ colItem.quantidade_membros_titulares_maximo || 'Não informado' }}
                        </template>
                        <template v-else-if="coluna.field === 'quantidade_membros_suplentes_minimo'">
                          {{ colItem.quantidade_membros_suplentes_minimo || 'Não informado' }}
                        </template>
                        <template v-else-if="coluna.field === 'quantidade_membros_suplentes_maximo'">
                          {{ colItem.quantidade_membros_suplentes_maximo }}
                        </template>
                        <template v-else-if="coluna.field === 'permite_reconducao'">
                          {{ colItem.permite_reconducao ? 'Sim' : 'Não' }}
                          <span v-if="colItem.permite_reconducao && colItem.quantidade_reconducao">(Qtd: {{ colItem.quantidade_reconducao }})</span>
                        </template>
                        <template v-else-if="coluna.field === 'duracao_mandato'">
                          {{ colItem.duracao_mandato ? colItem.duracao_mandato + ' anos' : 'Não informada' }}
                        </template>
                        <template v-else-if="coluna.field === 'remunerado'">
                          {{ colItem.remunerado ? 'Sim' : 'Não' }}
                          <span v-if="colItem.remunerado && colItem.valor_remunerado"> ({{ colItem.valor_remunerado }})</span>
                        </template>
                        <template v-else-if="coluna.field === 'sabatina_alego'">
                          <span v-if="colItem.sabatina_alego !== null">{{ colItem.sabatina_alego ? 'Sim' : 'Não' }}</span>
                          <span v-else>Não informado</span>
                        </template>
                        <template v-else-if="coluna.field === 'lista_triplice'">
                          <span v-if="colItem.lista_triplice !== null">{{ colItem.lista_triplice ? 'Sim' : 'Não' }}</span>
                          <span v-else>Não informado</span>
                        </template>
                        <template v-else-if="coluna.field === 'cargo_presidente'">
                          <span v-if="colItem.cargo_presidente !== null">{{ colItem.cargo_presidente ? 'Sim' : 'Não' }}</span>
                          <span v-else>Não informado</span>
                        </template>
                      </td>
                    </template>
                  </tr>
                </tbody>

              </table>
            </div>

            <!-- Seção 2: Mandatos do Colegiado -->
            <div class="pdf-section" v-if="exportarMandatos">
              <h2 v-if="pagIdx === 0" class="pdf-section-title">
                {{ exportarInfosGerais ? '2. Mandatos' : '1. Mandatos' }}
              </h2>
              <div v-if="paginaMandatos.length === 0" class="pdf-no-data-msg">
                Nenhum mandato correspondente aos filtros de status selecionados nesta folha.
              </div>
              <table v-else :class="['pdf-table-planilha', classeTabela]">
                <thead>
                  <tr>
                    <th v-for="coluna in obterColunasSelecionadas(colItem)" 
                    :key="coluna.field"
                    :class="{ 'pdf-index-col-head': coluna.field === 'index_col' }"
                    >
                      {{ coluna.label }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mandato, idx) in paginaMandatos" :key="mandato.id">
                    <td v-for="coluna in obterColunasSelecionadas(colItem)" 
                    :key="coluna.field"
                    :class="{ 'pdf-index-col-cell': coluna.field === 'index_col' }"
                    >
                      <template v-if="coluna.field === 'index_col'">
                        <!-- Compensa a diferença de tamanho da primeira página -->
                        {{ pagIdx === 0 ? idx + 1 : (exportarInfosGerais ? 4 : 8) + (pagIdx - 1) * 8 + idx + 1 }}
                      </template>
                      <template v-else-if="coluna.field === 'cpf_membro'">
                        {{ formatarCPF(mandato.cpf_membro) }}
                      </template>
                      <template v-else-if="coluna.field === 'data_inicio' || coluna.field === 'data_termino'">
                        {{ formatarData(mandato[coluna.field]) }}
                      </template>
                      <template v-else-if="coluna.field === 'funcao'">
                        {{ getFuncao(mandato.funcao) }}
                      </template>
                      <template v-else-if="coluna.field === 'tipo_membro'">
                        {{ formatarTipoMembro(mandato.tipo_membro) }}
                      </template>
                      <template v-else-if="coluna.field === 'tipo_mandato'">
                        {{ formatarTextoMaiusculas(mandato.tipo_mandato) }}
                      </template>
                      <template v-else-if="coluna.field === 'categoria_representativa'">
                        {{ formatarTextoMaiusculas(mandato.categoria_representativa) }}
                      </template>
                      <template v-else-if="coluna.field === 'cargo_membro'">
                        {{ formatarTextoMaiusculas(mandato.cargo_membro) }}
                      </template>
                      <template v-else-if="coluna.field === 'status_mandato'">
                        {{ formatarTextoMaiusculas(mandato.status_mandato) }}
                      </template>
                      <template v-else-if="coluna.field === 'link_ato_nomeacao'">
                        <span class="truncate-link" :title="mandato.link_ato_nomeacao">
                          {{ mandato.link_ato_nomeacao ? mandato.link_ato_nomeacao.substring(0, 30) + '...' : 'Não informado' }}
                        </span>
                      </template>
                      
                      <!-- Célula do Nome do Membro com a Função logo abaixo (Se for Presidente/Vice) -->
                      <template v-else-if="coluna.field === 'nome_membro'">
                        <strong v-if="mandato.nome_membro === 'Cargo Vago'">
                          {{ mandato.nome_membro }}
                        </strong>
                        <span v-else>
                          {{ mandato.nome_membro ? mandato.nome_membro.toUpperCase() : '' }}
                          <template v-if="isPresidenteOuVice(mandato)">
                            <br>
                            <small style="color: #718096; font-weight: normal; display: block; margin-top: 2px; font-size: 0.75rem;">
                              ({{ getFuncaoFormatada(mandato.funcao) }})
                            </small>
                          </template>
                        </span>
                      </template>

                      
                      <template v-else>
                        {{ mandato[coluna.field] }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </template>

        <!-- Bloco de Observações-->
        <div 
          v-if="observacaoUsuario && observacaoUsuario.trim()" 
          class="pdf-page-wrapper quebra-pagina-lote-sempre"
        >
          <div class="pdf-info-text-blocks" style="margin-top: 10px;">
            <div class="pdf-text-block">
              <!-- <span class="pdf-block-label">Observações do Relatório</span> -->
              <p class="pdf-block-value">{{ observacaoUsuario }}</p>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { parseISO, format } from "date-fns"
import html2pdf from 'html2pdf.js'
import html2canvas from 'html2canvas' 
import MandatosApi from "../../services/MandatosApi"
import vSelect from 'vue-select'
import CabecalhoPdf from '../pdf_components/Cabecalho.vue'

export default {
  name: 'ConstruirPdf',
  components: {
    vSelect,
    CabecalhoPdf
  },
  props: {
    colegiado: {
      type: Object,
      required: false,
      default: null
    },
    mandatos: {
      type: Array,
      default: () => []
    },
    filename: {
      type: String,
      default: 'documento.pdf'
    },
    orientation: {
      type: String,
      default: 'portrait'
    },
    selectedOrgao: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      gerando: false,
      observacaoUsuario: '',
      dataAtual: format(new Date(), 'dd/MM/yyyy'),
      
      // VIGENTE PRÉ-SELECIONADO POR PADRÃO
      StatusFiltro: ['vigente', 'Vigente', 'VIGENTE'], 
      
      exportarInfosGerais: true,
      exportarMandatos:true,

      colegiadosLote: [],
      colegiadosFiltro: [],
      carregandoDadosLote: false,
      draggedIndex: null,
      draggedIndexColegiado: null,

      mostrarPersonalizacao: false,

      selectedOrgaoSelecionado: this.selectedOrgao,
      orgaos: [],
      optionsOrgaos: [],
      search: '',
      limit: 10,
      offset: 0,
      erroFiltro: false,

      // ********* MANDATOS *********
      camposMandato: {
        index_col: 'Nº',
        nome_membro: 'Nome do Membro',
        data_inicio: 'Data de Início',
        data_termino: 'Data de Término',
        cpf_membro: 'CPF do Membro',
        funcao: 'Função do Membro',
        tipo_membro: 'Tipo de Membro',
        tipo_mandato: 'Tipo de Mandato',
        status_mandato: 'Status do Mandato',
        id: 'Código SISCOL (Membro Atual)',
        cargo_membro: 'Cargo',
        categoria_representativa: 'Categoria Representada',
        ato_nomeacao: 'Ato de Nomeação',
        link_ato_nomeacao: 'Link do Diário Oficial (Ato)',
        mandatos_id: 'Código Membro Anterior'
      },

      ordemCampos: [
        'index_col',
        'nome_membro',
        'cpf_membro',
        'data_inicio',
        'data_termino',
        'tipo_mandato',
        'tipo_membro',
        'funcao',
        'status_mandato',
        'id',
        'cargo_membro',
        'categoria_representativa',
        'ato_nomeacao',
        'link_ato_nomeacao',
        'mandatos_id'
      ],

      camposSelecionados: {
        index_col: true,
        nome_membro: true,
        cpf_membro: true,
        data_inicio: true,
        data_termino: true,
        tipo_mandato: true,
        tipo_membro: true,
        funcao: false,
        status_mandato: false,
        id: false, 
        cargo_membro: true, 
        categoria_representativa: false,
        ato_nomeacao: false,
        link_ato_nomeacao: false,
        mandatos_id: false
      },

      // ********* COLEGIADO *********
      camposColegiado: {
        quantidade_membros_titulares_minimo: 'Membros Titulares Mín',
        quantidade_membros_titulares_maximo: 'Membros Titulares Máx',
        quantidade_membros_suplentes_minimo: 'Membros Suplentes Mín',
        quantidade_membros_suplentes_maximo: 'Membros Suplentes Máx',
        duracao_mandato: 'Duração do Mandato',
        permite_reconducao: 'Permite Recondução',
        remunerado: 'Remunerado',
        sabatina_alego: 'Sabatina da Alego',
        lista_triplice: 'Lista Tríplice',
        cargo_presidente: 'Cargo Presidente',
      },

      ordemColegiado: [
        'quantidade_membros_titulares_minimo',
        'quantidade_membros_titulares_maximo',
        'quantidade_membros_suplentes_minimo',
        'quantidade_membros_suplentes_maximo',
        'duracao_mandato',
        'permite_reconducao',
        'remunerado',
        'sabatina_alego',
        'lista_triplice',
        'cargo_presidente'
      ],

      camposColegiadoSelecionados: {
        quantidade_membros_titulares_minimo: false,
        quantidade_membros_titulares_maximo: true,
        quantidade_membros_suplentes_minimo: false,
        quantidade_membros_suplentes_maximo: true,
        duracao_mandato: true,
        permite_reconducao: true,
        remunerado: true,
        sabatina_alego: false,
        lista_triplice: false,
        cargo_presidente: false
      },
    }
  },

  created() {
    this.ColegiadoApi = new (require('../../services/ColegiadoApi').default)();
    this.mandatosApi = new MandatosApi();
    this.carregarValoresFiltro();
    if (this.selectedOrgaoSelecionado) {
      this.carregarDadosLoteAoMarcar();
    }
  },

  computed: {
    exportarLoteOrgao() {
      return this.colegiadosFiltro.length > 1
    },

    statusDisponiveis() {
      let todosMandatos = []
      if (this.colegiadosFiltradosLote.length > 0) {
        this.colegiadosFiltradosLote.forEach(col => {
          if (col.mandatosDoLote) {
            todosMandatos.push(...col.mandatosDoLote)
          }
        })
      } else {
        todosMandatos = this.mandatos || []
      }

      const statusMapeados = todosMandatos
        .map(mandato => mandato.status_mandato)
        .filter(status => status !== null && status !== undefined && status !== '')
        
      return [...new Set(statusMapeados)].sort()
    },

    colegiadosFiltradosLote() {
      if (!this.colegiadosLote) return []
      return this.colegiadosLote.filter(col => this.colegiadosFiltro.includes(col.id))
    },

    marcarTodosColegiados: {
      get() {
        return this.colegiadosLote.length > 0 && this.colegiadosFiltro.length === this.colegiadosLote.length
      },
      set(value) {
        if (value) {
          this.colegiadosFiltro = this.colegiadosLote.map(col => col.id)
        } else {
          this.colegiadosFiltro = []
        }
      }
    },

    filteredOrgaos() {
      if (!this.search) return this.optionsOrgaos;

      const termo = this.search.toLowerCase().trim();
      return this.optionsOrgaos.filter(orgao => {
        const nome = (orgao.nome || '').toLowerCase();
        const sigla = (orgao.sigla || '').toLowerCase();
        const nomeSigla = `${orgao.nome || ''} - ${orgao.sigla || ''}`.toLowerCase();

        return nome.includes(termo)
          || sigla.includes(termo)
          || nomeSigla.includes(termo);
      });
    },
    paginated() {
      return this.filteredOrgaos.slice(this.offset, this.offset + this.limit);
    },
    hasPrevPage() {
      return this.offset > 0;
    },
    hasNextPage() {
      return this.offset + this.limit < this.filteredOrgaos.length;
    },

    marcarTodosCampos: {
      get() {
        const chaves = Object.keys(this.camposSelecionados).filter(k => k !== 'index_col')
        return chaves.length > 0 && chaves.every(chave => this.camposSelecionados[chave])
      },
      set(value) {
        const chaves = Object.keys(this.camposSelecionados).filter(k => k !== 'index_col')
        chaves.forEach(chave => {
          this.camposSelecionados[chave] = value
        })
      }
    },

    marcarTodosCamposColegiado: {
      get() {
        const chaves = Object.keys(this.camposColegiadoSelecionados)
        return chaves.length > 0 && chaves.every(chave => this.camposColegiadoSelecionados[chave])
      },
      set(value) {
        const chaves = Object.keys(this.camposColegiadoSelecionados)
        chaves.forEach(chave => {
          this.camposColegiadoSelecionados[chave] = value
        })
      }
    },
    
    marcarTodosStatus: {
      get() {
        return this.statusDisponiveis.length > 0 && this.StatusFiltro.length === this.statusDisponiveis.length
      },
      set(value) {
        if (value) {
          this.StatusFiltro = [...this.statusDisponiveis]
        } else {
          this.StatusFiltro = []
        }
      }
    },

    colunasSelecionadas() {
      return this.ordemCampos
        .filter(field => this.camposSelecionados[field])
        .map(field => ({
          field,
          label: this.camposMandato[field]
        }))
    },

    colunasColegiadoSelecionadas() {
      return this.ordemColegiado
        .filter(field => this.camposColegiadoSelecionados[field])
        .map(field => ({
          field,
          label: this.camposColegiado[field]
        }))
    },

    classeTabela() {
      const totalColunas = this.colunasSelecionadas.length
      if (totalColunas <= 4) {
        return 'tabela-larga'
      } else if (totalColunas <= 7) {
        return 'tabela-media'
      } else if (totalColunas <= 10) {
        return 'tabela-compacta'
      } else {
        return 'tabela-super-compacta'
      }
    }
  },

  watch: {
    selectedOrgao: {
      handler(value) {
        this.selectedOrgaoSelecionado = value;
      }
    },
    selectedOrgaoSelecionado(value) {
      if (value) {
        this.carregarDadosLoteAoMarcar();
      } else {
        this.colegiadosLote = [];
        this.colegiadosFiltro = [];
      }
    }
  },

  methods: {
    isPresidenteOuVice(mandato) {
      if (!mandato || !mandato.funcao) return false;
      const funcao = mandato.funcao
        .toLowerCase()
        .trim()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
        
      return funcao === 'presidente' || funcao === 'vice-presidente' || funcao === 'vicepresidente';
    },

      // Formata esteticamente o texto da função
      getFuncaoFormatada(funcao) {
        if (!funcao) return '';
        const f = funcao.toLowerCase().trim();
        if (f === 'presidente') return 'Presidente';
        if (f === 'vicepresidente' || f === 'vice-presidente') return 'Vice-Presidente';
        return this.formatarTextoMaiusculas(funcao);
      },
      
    // Retorna as colunas corretas filtrando Cargo, Categoria Representada e Tipo de Membro
    obterColunasSelecionadas(colItem) {
      const isDiretoria = colItem.tipo === 'diretoria' || colItem.nome === 'Diretoria Executiva';
      
      const mandatosDoColegiado = colItem.mandatosDoLote || [];
      const temCategoriaPreenchida = mandatosDoColegiado.some(m => {
        return m.categoria_representativa && 
               m.categoria_representativa.trim() !== '' && 
               m.categoria_representativa !== '-';
      });

      return this.ordemCampos
        .filter(field => {
          if (!this.camposSelecionados[field]) return false;

          // Coluna Cargo: Exclusiva para Diretorias
          if (field === 'cargo_membro') return isDiretoria;
          
          // Categoria Representada: Oculta em Diretorias e exibe nos demais apenas se houver preenchimento
          // Exclusiva de colegiados não-remunerados, porém há exceções
          if (field === 'categoria_representativa') return !isDiretoria && temCategoriaPreenchida;
          
          // Tipo de Membro (Titular/Suplente): Oculta apenas em Diretorias
          if (field === 'tipo_membro') return !isDiretoria;
          
          return true;
        })
        .map(field => ({
          field,
          label: this.camposMandato[field]
        }));
    },

    obterMandatosComVagos(colItem) {
      const listaOriginal = colItem.mandatosDoLote || []
      let filtrados = listaOriginal.filter(m => this.StatusFiltro.includes(m.status_mandato))
      
      const titularesAtivos = filtrados.filter(m => (m.tipo_membro || '').toLowerCase().trim() === 'titular')
      const suplentesAtivos = filtrados.filter(m => (m.tipo_membro || '').toLowerCase().trim() === 'suplente')
      
      const maxTitulares = colItem.quantidade_membros_titulares_maximo || 0
      const maxSuplentes = colItem.quantidade_membros_suplentes_maximo || 0
      
      let resultado = [...filtrados]
      
      if (titularesAtivos.length < maxTitulares) {
        const vagas = maxTitulares - titularesAtivos.length
        for (let i = 0; i < vagas; i++) {
          resultado.push({
            id: `vago-titular-${colItem.id}-${i}`,
            nome_membro: 'Cargo Vago',
            tipo_membro: 'titular',
            cpf_membro: '-',
            funcao: '-',
            tipo_mandato: '-',
            status_mandato: 'vigente',
            cargo_membro: '-',
            categoria_representativa: '-',
            ato_nomeacao: '-',
            link_ato_nomeacao: ''
          })
        }
      }
      
      if (suplentesAtivos.length < maxSuplentes) {
        const vagas = maxSuplentes - suplentesAtivos.length
        for (let i = 0; i < vagas; i++) {
          resultado.push({
            id: `vago-suplente-${colItem.id}-${i}`,
            nome_membro: 'Cargo Vago',
            tipo_membro: 'suplente',
            cpf_membro: '-',
            funcao: '-',
            tipo_mandato: '-',
            status_mandato: 'vigente',
            cargo_membro: '-',
            categoria_representativa: '-',
            ato_nomeacao: '-',
            link_ato_nomeacao: ''
          })
        }
      }
      
      return resultado.sort((a, b) => {
        const funcaoA = (a.funcao || '').toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const funcaoB = (b.funcao || '').toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

        const normalizaFuncao = valor => valor
          .replace(/[-_\s]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()

        const funcaoNormalizadaA = normalizaFuncao(funcaoA)
        const funcaoNormalizadaB = normalizaFuncao(funcaoB)

        const pesoA = funcaoNormalizadaA === 'presidente' ? 1
          : (funcaoNormalizadaA === 'vice presidente' || funcaoNormalizadaA === 'vicepresidente' ? 2 : 3)

        const pesoB = funcaoNormalizadaB === 'presidente' ? 1
          : (funcaoNormalizadaB === 'vice presidente' || funcaoNormalizadaB === 'vicepresidente' ? 2 : 3)

        if (pesoA !== pesoB) {
          return pesoA - pesoB
        }

        const nomeA = ((a.nome_membro || '').toLowerCase().trim())
        const nomeB = ((b.nome_membro || '').toLowerCase().trim())

        if (nomeA === 'cargo vago' && nomeB !== 'cargo vago') return 1
        if (nomeB === 'cargo vago' && nomeA !== 'cargo vago') return -1

        return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' })
      })
    },

    onSearch(query) {
      this.search = query
      this.offset = 0
    },

    setarOptions() {
      this.optionsOrgaos = this.orgaos.map(orgao => ({
        id: orgao.id,
        nome: orgao.nome,
        sigla: orgao.sigla || '',
        label: `${orgao.nome} - ${orgao.sigla || ''}`
      }))
    },

    async carregarValoresFiltro() {
      try {
        this.erroFiltro = false;
        const response = await this.ColegiadoApi.getOrgao();
        this.orgaos = response || [];
        this.setarOptions();
      } catch (err) {
        console.error("Erro ao carregar valores de filtro do órgão:", err);
        this.erroFiltro = true;
      }
    },

    formatarCPF(cpf) {
      if (!cpf || cpf === '-') return '-'
      cpf = cpf.replace(/\D/g, '')
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2')
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      return cpf
    },
    formatarData(value) {
      if (!value || value === '-') return '-'
      try {
        return format(parseISO(value), "dd/MM/yyyy")
      } catch (e) {
        return value
      }
    },
    getFuncao(value) {
      if (value === 'vicepresidente') {
        return 'Vice-Presidente'
      } else if (value === 'presidente') {
        return 'Presidente'
      }
      return value || 'Membro'
    },
    formatarTipoMembro(value) {
      if (!value || value === '-') return '-'
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    },
    formatarStatus(value) {
      const statusList = {
        em_estruturacao: 'Em estruturação',
        ativo: 'Ativo',
        inativo: 'Inativo'
      }
      return statusList[value] || value
    },
    formatarTextoMaiusculas(value) {
      if (!value || value === '-') return '-'
      const preposicoes = ['a', 'de', 'da', 'do', 'das', 'dos', 'e', 'com', 'em', 'no', 'na', 'nos', 'nas', 'para', 'por', 'di']
      return value
        .toLowerCase()
        .split(' ')
        .map((palavra, index) => {
          if (preposicoes.includes(palavra) && index !== 0) {
            return palavra
          }
          return palavra.charAt(0).toUpperCase() + palavra.slice(1)
        })
        .join(' ')
    },

    iniciarArrasto(index, event) {
      if (!event || !event.dataTransfer) return
      this.draggedIndex = index
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.setData('text/plain', String(index))
    },
    aoPassarPorCima(index, event) {
      if (!event || !event.preventDefault) return
      event.preventDefault()
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'move'
      }
    },
    aoSoltar(targetIndex, event) {
      if (event && event.preventDefault) {
        event.preventDefault()
      }
      if (this.draggedIndex === null || this.draggedIndex === targetIndex || targetIndex === 0) return
      const novaOrdem = [...this.ordemCampos]
      const [itemArrastado] = novaOrdem.splice(this.draggedIndex, 1)
      novaOrdem.splice(targetIndex, 0, itemArrastado)
      this.ordemCampos = novaOrdem
      this.draggedIndex = null
    },
    fimArrasto() {
      this.draggedIndex = null
    },
    iniciarArrastoColegiado(index, event) {
      if (!event || !event.dataTransfer) return
      this.draggedIndexColegiado = index
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.setData('text/plain', String(index))
    },
    aoSoltarColegiado(targetIndex, event) {
      if (event && event.preventDefault) {
        event.preventDefault()
      }
      if (this.draggedIndexColegiado === null || this.draggedIndexColegiado === targetIndex) return
      const novaOrdem = [...this.ordemColegiado]
      const [itemArrastado] = novaOrdem.splice(this.draggedIndexColegiado, 1)
      novaOrdem.splice(targetIndex, 0, itemArrastado)
      this.ordemColegiado = novaOrdem
      this.draggedIndexColegiado = null
    },
    fimArrastoColegiado() {
      this.draggedIndexColegiado = null
    },

    async carregarDadosLoteAoMarcar() {
      const orgaoId = this.selectedOrgaoSelecionado?.id
      if (!orgaoId) return

      try {
        this.carregandoDadosLote = true
        const responseColegiados = await this.ColegiadoApi.getColegiados({ orgao_id: orgaoId, qtd_por_pagina: 100 })
        const listaColegiados = responseColegiados?.colegiados || responseColegiados?.resultados || []

        if (listaColegiados.length === 0) {
          alert('Nenhum colegiado associado a esse órgão foi encontrado.')
          return
        }

        const resolucoesDeMandatos = listaColegiados.map(async (col) => {
          try {
            const respostaMandatos = await this.mandatosApi.getMandatos({
              colegiados_id: col.id,
              qtd_por_pagina: 100
            })
            return {
              ...col,
              mandatosDoLote: respostaMandatos?.resultados || []
            }
          } catch (e) {
            console.error(`Erro ao buscar mandatos do colegiado ${col.id}:`, e)
            return { ...col, mandatosDoLote: [] }
          }
        })

        this.colegiadosLote = await Promise.all(resolucoesDeMandatos)
        this.colegiadosFiltro = this.colegiadosLote.map(col => col.id)
      } catch (erro) {
        console.error('Erro ao pré-carregar dados do lote:', erro)
        alert('Ocorreu um erro ao carregar os dados dos outros colegiados.')
      } finally {
        this.carregandoDadosLote = false
      }
    },

    gerarNomeArquivo() {
      const orgaoNome = this.selectedOrgaoSelecionado?.nome || this.selectedOrgaoSelecionado?.sigla || 'Orgao'
      const nomeArquivo = this.colegiadosFiltradosLote.length === 1
        ? `${this.colegiadosFiltradosLote[0].nome} - ${orgaoNome}`
        : `Colegiados de ${orgaoNome}`
      const nomeSeguro = nomeArquivo
        .split('')
        .map(caractere => {
          const codigo = caractere.charCodeAt(0)
          return codigo < 32 || '<>:"/\\|?*'.includes(caractere) ? '-' : caractere
        })
        .join('')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/[. ]+$/g, '')

      return `${nomeSeguro || 'colegiados'}.pdf`
    },

    obterPaginasDoColegiado(colItem) {
      if (!this.exportarMandatos) {
        return [[]] // Retorna uma página vazia para forçar o render apenas da composição
      }

      const mandatosDoColegiado = this.obterMandatosComVagos(colItem)
      if (mandatosDoColegiado.length === 0) return [[]]

      const paginas = []
      // 4 registros na página 1 (devido ao bloco de composição); 8 registros nas páginas subsequentes
      let limitePrimeiraPagina = this.exportarInfosGerais ? 4 : 8
      let limiteDemaisPaginas = 8

      paginas.push(mandatosDoColegiado.slice(0, limitePrimeiraPagina))

      let cursor = limitePrimeiraPagina
      while (cursor < mandatosDoColegiado.length) {
        paginas.push(mandatosDoColegiado.slice(cursor, cursor + limiteDemaisPaginas))
        cursor += limiteDemaisPaginas
      }
      return paginas
    },

    async gerarPdf() {
      if (this.colegiadosFiltro.length === 0) {
        alert('Por favor, selecione ao menos um Colegiado para realizar a exportação.')
        return
      }
      if (!this.exportarInfosGerais && !this.exportarMandatos) {
        alert('Por favor, selecione ao menos uma seção para exportar (Composição ou Mandatos).')
        return
      }

      if (this.exportarMandatos && this.statusDisponiveis.length > 0 && (!this.StatusFiltro || this.StatusFiltro.length === 0)) {
        alert('Por favor, selecione ao menos um filtro de status antes de gerar o PDF.')
        return
      }

      try {
        this.gerando = true
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 500))

        const outputFilename = this.gerarNomeArquivo()
        
        // 1. Renderiza o banner do cabeçalho uma única vez na memória
        const headerTemplate = this.$refs.cabecalhoPdf?.$refs?.headerBannerTemplate
        const canvasHeader = await html2canvas(headerTemplate, {
          useCORS: true,
          scale: 2,
          backgroundColor: '#f4f5f7'
        })
        const headerImgData = canvasHeader.toDataURL('image/png')

        // 2. Define margens com folga ideal de segurança (Top: 48mm, Bottom: 12mm)
        const options = {
          margin: [55, 15, 12, 15],
          filename: outputFilename,
          image: { type: 'jpeg', quality: 1 },
          html2canvas: { 
            scale: 2, 
            useCORS: true, 
            logging: false,
            scrollY: 0,
            scrollX: 0
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
          pagebreak: { mode: ['css'] } 
        }

        this.dataAtual = format(new Date(), 'dd/MM/yyyy')

        // 3. Mapeia estritamente qual título e rodapé pertencem a cada folha
        const paginasConfig = []
        this.colegiadosFiltradosLote.forEach(colItem => {
          const paginas = this.obterPaginasDoColegiado(colItem)
          paginas.forEach((pagina, pagIdx) => {
            paginasConfig.push({
              orgaoTexto: this.selectedOrgaoSelecionado ? `${this.selectedOrgaoSelecionado.nome} – ${this.selectedOrgaoSelecionado.sigla || ''}` : '',
              tituloColegiado: colItem.nome + (colItem.sigla ? ' – ' + colItem.sigla : ''),
              pagIdx: pagIdx
            })
          })
        })
        
        if (this.observacaoUsuario && this.observacaoUsuario.trim()) {
          paginasConfig.push({
            orgaoTexto: this.selectedOrgaoSelecionado ? `${this.selectedOrgaoSelecionado.nome} – ${this.selectedOrgaoSelecionado.sigla || ''}` : '',
            tituloColegiado: 'Observações Gerais',
            pagIdx: 0
          })
        }

        // Executa a conversão baseada em fatiamento
        const pdfInstance = await html2pdf().set(options).from(this.$refs.printableArea).toPdf().get('pdf')
        const totalPages = pdfInstance.internal.getNumberOfPages();
        
        // 4. Injeta os elementos estáticos e dinâmicos
        for (let i = 1; i <= totalPages; i++) {
          pdfInstance.setPage(i);

          // Desenha o cabeçalho fixo
          pdfInstance.addImage(headerImgData, 'PNG', 15, 10, 267, 20);

          const config = paginasConfig[i - 1];
          if (config) {
            
            pdfInstance.setFont('helvetica');
            if (pdfInstance.setFontStyle) {
              pdfInstance.setFontStyle('bold');
            } else {
              pdfInstance.setFont('helvetica', 'bold'); // Fallback para versões mais recentes
            }

            pdfInstance.setFontSize(15);
            pdfInstance.setTextColor(0, 85, 22);
            
            pdfInstance.text(config.orgaoTexto, 148.5, 36, { align: 'center' });
            pdfInstance.text(config.orgaoTexto, 148.6, 36, { align: 'center' }); // +0.1mm de espessura
            
            let colText = config.tituloColegiado;
            // 'Continuação' do colegiado: descontinuado
            // if (config.pagIdx > 0) {
            //   colText += ` (Continuação - Folha ${config.pagIdx + 1})`;
            // }
            pdfInstance.setFontSize(13);
            pdfInstance.setTextColor(45, 55, 72); // Cinza Escuro #2d3748
            
            pdfInstance.text(colText, 148.5, 42, { align: 'center' });
            pdfInstance.text(colText, 148.6, 42, { align: 'center' }); // +0.1mm de espessura
          }

          // Desenha o rodapé fixo (Y = 201mm)
          pdfInstance.setFont('helvetica', 'normal');
          if (pdfInstance.setFontStyle) {
            pdfInstance.setFontStyle('normal');
          }
          pdfInstance.setFontSize(8);
          pdfInstance.setTextColor(113, 128, 150);
          
          pdfInstance.text('Sistema de Colegiados – SISCOL', 15, 201);
          pdfInstance.text(String(i), 148.5, 201, { align: 'center' });
          pdfInstance.text(this.dataAtual, 272, 201);
        }

        
        await pdfInstance.save(outputFilename)
        this.$emit('concluido')

      } catch (erro) {
        console.error('Erro ao gerar PDF:', erro)
        alert('Ocorreu um erro ao gerar o PDF. Por favor, tente novamente.')
      } finally {
        this.gerando = false
      }
    }



  }
}
</script>

<style scoped>
/* Estilização Geral do Painel */
.construir-pdf {
  font-family: 'Montserrat', Arial, sans-serif;
  font-weight: 600;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06);
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
  text-align: left;
  display: flex;
  flex-direction: column;
}

.config-panel {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.config-header {
  margin-bottom: 20px;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 12px;
}

.config-header h3 {
  color: #005516;
  margin: 0 0 6px 0;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
}

.config-header p {
  color: #718096;
  margin: 0;
  font-size: 0.95rem;
}

.status-filter-section {
  margin-bottom: 20px;
  background-color: #fcfdfd;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #edf2f7;
}

.fields-filter-section {
  margin-bottom: 20px;
}

.section-subtitle {
  color: #2d3748;
  margin: 0 0 12px 0;
  font-size: 1.05rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

/* Grid de Checkboxes */
.checkbox-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.drag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: stretch;
}

.drag-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background-color: white;
  padding: 14px 16px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  min-width: 260px;
  flex: 0 1 auto;
  box-sizing: border-box;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.drag-card.arrastando {
  border-color: #005516;
  box-shadow: 0 0 0 2px rgba(0, 85, 22, 0.15);
}

.drag-card:hover {
  border-color: #005516;
}

.drag-handle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #718096;
  cursor: grab;
  padding: 0 10px 0 0;
}

.checkbox-item {
  width: calc(33.333% - 8px);
  min-width: 230px;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #edf2f7;
  font-size: 0.95rem;
  color: #2d3748;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.checkbox-item:hover {
  border-color: #005516;
  background-color: #f0fff4;
}

.checkbox-item input {
  width: 17px;
  height: 17px;
  accent-color: #005516;
  cursor: pointer;
}

.checkbox-item.status-box {
  border-left: 4px solid #005516;
}

.no-status-msg {
  color: #a0aec0;
  font-style: italic;
  font-size: 0.9rem;
  margin: 0;
}

/* Botões do Painel */
.config-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: auto;
  border-top: 1px solid #edf2f7;
  padding-top: 16px;
}

.btn-cancelar {
  background-color: #e2e8f0;
  color: #4a5568;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-cancelar:hover {
  background-color: #cbd5e0;
}

.btn-gerar {
  background-color: #005516;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
}

.btn-gerar:hover {
  background-color: #004010;
}

.btn-gerar:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* =======================================================================
   ESTILOS EXCLUSIVOS DO GERADOR DE PDF (MODO PAISAGEM)
   ======================================================================= */
.pdf-preview-container {
  background-color: white;
  padding: 10px;
  margin-top: 20px;
  border: 1px dashed #cbd5e0;
}

.pdf-document {
  padding: 0mm !important;
}

.pdf-page-wrapper {
  width: 267mm !important; 
  height: 140mm !important; 
  max-height: 140mm !important;
  box-sizing: border-box !important;
  position: relative !important;
  background-color: #ffffff !important;
  overflow: hidden !important; 
  margin: 0 !important;
  padding: 0 !important;
}

.pdf-titles-section {
  margin-bottom: 20px;
  border-bottom: 2px solid #005516;
  padding-bottom: 4px;
}

.pdf-subtitulo-documento {
  font-family: 'Calibri', 'Montserrat', Arial, sans-serif;
  font-size: 1.35rem;
  color: #005516;
  font-weight: 900;
  margin: 0 0 4px 0;
}

.pdf-colegiado-titulo {
  font-family: 'Calibri', 'Montserrat', Arial, sans-serif;
  font-size: 1.15rem;
  color: #2d3748;
  font-weight: 700;
  margin: 0;
}

.pdf-continua-badge {
  color: #718096;
  font-size: 0.95rem;
  font-style: italic;
  font-weight: normal;
  display: block !important; /* Garante a quebra de linha de forma controlada */
  line-height: 1 !important;
}

.pdf-section {
  page-break-inside: avoid !important;
  break-inside: avoid !important;
  margin-bottom: 30px;
}

.pdf-section-title {
  color: #005516;
  border-bottom: 2px solid #005516;
  padding-bottom: 5px;
  margin-bottom: 15px;
  font-size: 1.25rem;
  font-weight: bold;
}

/* Tabelas do PDF */
.pdf-info-table,
.pdf-table-planilha {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  table-layout: fixed;
  page-break-inside: auto !important;
  break-inside: auto !important;
}

.pdf-table-planilha tbody tr {
  page-break-inside: avoid !important;
  break-inside: avoid !important;
}

/* Garante que o cabeçalho e rodapé da tabela evitem quebra interna */
.pdf-table-planilha thead {
  display: table-header-group !important; /* Ajuda navegadores a repetir o header na impressão */
}

.pdf-info-table th,
.pdf-table-planilha th {
  background-color: #005516 !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
  padding: 8px 10px;
  font-size: 9pt;
  border: 1px solid #cbd5e0;
  text-transform: uppercase;
}

.pdf-info-table td,
.pdf-table-planilha td {
  padding: 8px 10px;
  font-size: 8.5pt;
  border: 1px solid #cbd5e0;
  color: #2d3748;
  text-align: center;
  vertical-align: middle;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-weight: 700;
  break-inside: avoid !important;
}

.pdf-table-planilha tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.pdf-table-planilha tbody tr:nth-child(even) {
  background-color: #f2f7ff; /* Zebrado em azul claro suave */
}

/* --- ESCALONAMENTO DE ACORDO COM A QUANTIDADE DE COLUNAS --- */
.tabela-larga th {
  font-size: 10pt;
  padding: 8px 10px;
}
.tabela-larga td {
  font-size: 9.5pt;
  padding: 8px 10px;
}

.tabela-media th {
  font-size: 8.5pt;
  padding: 6px 8px;
}
.tabela-media td {
  font-size: 8pt;
  padding: 6px 8px;
}

.tabela-compacta th {
  font-size: 7.5pt;
  padding: 5px 6px;
}
.tabela-compacta td {
  font-size: 7pt;
  padding: 5px 6px;
}

.tabela-super-compacta th {
  font-size: 6.5pt;
  padding: 4px 4px;
}
.tabela-super-compacta td {
  font-size: 6pt;
  padding: 4px 4px;
}

/* Estilo para capelas e capas de Lote */
.pdf-cover-page {
  width: 267mm;
  height: 140mm;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-sizing: border-box;
}

.pdf-cover-content {
  width: 85%;
  margin: 0 auto;
  border: 2px solid #005516;
  border-radius: 12px;
  padding: 40px;
  background-color: #fcfdfc;
  box-shadow: 0 4px 10px rgba(0,0,0,0.02);
}

.pdf-index-col-head,
.pdf-index-col-cell {
  width: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  text-align: center !important;
}

.pdf-cover-title {
  color: #005516;
  font-size: 2.2rem;
  font-weight: 800;
  margin: 15px 0 10px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.pdf-cover-subtitle {
  color: #4a5568;
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 25px 0;
}

.pdf-cover-date {
  font-size: 1rem;
  color: #a0aec0;
}

.obs-input-section {
  margin: 18px 0 20px;
  padding: 14px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.obs-input-section p {
  margin: 0 0 10px 0;
  color: #2d3748;
  font-weight: 700;
}

.obs-input {
  width: 100%;
  min-height: 42px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #cbd5e0;
  background-color: white;
  color: #2d3748;
  box-sizing: border-box;
  font-family: 'Helvetica Neue', Arial, sans-serif;
}

.pdf-cover-obs,
.pdf-info-text-blocks {
  border-top: 1px dashed #cbd5e0;
  padding-top: 20px;
  margin-top: 30px;
  text-align: left;
}

.pdf-cover-obs .pdf-block-label,
.pdf-info-text-blocks .pdf-block-label {
  display: block;
  color: #005516;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.pdf-cover-obs .pdf-block-value,
.pdf-info-text-blocks .pdf-block-value {
  color: #2d3748;
  font-size: 0.95rem;
  margin: 0 0 0 0;
  line-height: 1.5;
  white-space: pre-wrap;
}

.pdf-info-text-blocks {
  margin-top: 20px;
}

.pdf-text-block {
  background-color: #f8fafc;
  border-left: 3px solid #005516;
  padding: 12px 14px;
  border-radius: 4px;
}

.quebra-pagina-lote-sempre {
  page-break-before: always !important;
  break-before: page !important;
}

/* Transições de animação do painel */
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
